import React , { useEffect } from 'react';
import CustomerForm from '../components/CustomersModule/CustomerForm';

function AlertModal(props) {


  // Function to handle keypress
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      // props.setShowModal(false);
    props.handleOkay();
    }
  };

  // Add event listener when the modal is open
  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []); // Runs once when the component mounts

  return (
    <>
      <div style={{ display: 'block' }} className="modal-alert-sm modal fade show" id="role-modal" tabIndex="1000"
        aria-labelledby="exampleModalLabel">
        <div className="max-width-alert modal-dialog modal-dialog-centered modal-dialog-scrollable modal-width zoom-in">
          <div className="modal-content relative-container">
            <div className='pass-modal-head text-center'>
              <span className='pe-4'>{props.title}</span>
            </div>
            {props.showModal && (
              <button
                style={{ zIndex: '20' }}
                className="st-close-ic-btn mf-crop-close-btn"
                onClick={() => {

                  props.setShowModal(false);
                }}
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="icon-Close"></i>
              </button>
            )}

            <div className="row relative-container m-0 ">
              <div className='role-content '>

                <div className="mf-body   m-2 mt-4">
                  <div className="mf-body-wrapper text-center align-center text-16 mx-3">
                    <span>{props.content}</span>

                  </div>

{(props.data && props.data.length>1) &&
                  <div className='d-flex mt-2 flex-wrap justify-content-center'>
                  {props.data.map((val,index) => {
      
                    return (
                      <>{val.angle_page_number!==null &&
                      <div
                        key={index}
                        className={`mx-2 cursor-default button-rounded-pipe d-flex justify-content-evenly ${
                          true ? 'active button-rounded-pipe-checked' : ''
                        } ${true ? 'disabled' : ''}`}
                      
                      >
                        <label className="container">
                          <input 
                            type="checkbox" 
                            checked 
                            disabled
                            readOnly 
                          />
                          <div className="checkmark"></div>
                        </label>
                        <span className='mx-3'>
                         Page {parseInt(val.angle_page_number)+1}
                         
                        </span>
                      </div>
                  }</>
                    );
                  })}

                </div>
}

                
                  {!props.button2 ? <div className='align-center my-3'>
              
              <button className='add-customer-btn add-user-btn p-2 align-center mb-3' onClick={props.handleOkay}>
                          <span>{props.button}</span>
                    </button>
                  
                              </div>  
            :
              <>
                   <div className='d-flex justify-content-evenly my-3'>
                    <button className='max-width-200 add-user-btn p-2 align-center mb-3' onClick={props.handleOkay}>
                      <span>{props.button}</span>
                    </button>
                   
                    <button className='no-btn max-width-200 add-user-btn p-2 align-center mb-3'  onClick={() => {props.setShowModal(false);}}>
                      <span>{props.button2}</span>
                    </button>
                  </div>
                  </>
              }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>

  )
}

export default AlertModal;
